module.exports = __webpack_public_path__ + "img/27.1f23dfdb.png";